export const trimToTwoDecimals = (number: number) =>
  Number(number.toString().match(/^-?\d+(?:\.\d{0,2})?/)?.[0]);
